import { render, staticRenderFns } from "./epidemic.vue?vue&type=template&id=5b627e4c"
import script from "./epidemic.vue?vue&type=script&lang=js"
export * from "./epidemic.vue?vue&type=script&lang=js"
import style0 from "./epidemic.vue?vue&type=style&index=0&id=5b627e4c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports